module.exports = __webpack_public_path__ + "media/application/images/logo-ccfa6a9e4fc55445d5bb056c5f5bbad7.png";